import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import { InfoIconWrapper } from './styles';

interface InfoTooltipProps {
  text: string;
}

export const InfoTooltip = ({ text }: InfoTooltipProps) => (
  <Tooltip title={text} trigger={['hover', 'click']} overlayStyle={{ maxWidth: 280, fontSize: 14 }}>
    <InfoIconWrapper>
      <QuestionCircleOutlined />
    </InfoIconWrapper>
  </Tooltip>
);
